module.exports = __webpack_public_path__ + "static/img/11bg_9.1303770.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/11bg_9.png
// module id = 637
// module chunks = 1